var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacKfw55(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "167px",
    height: "247px",
    viewBox: "-0.5 -0.5 167 247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 L 3 125",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 M 3 243 C 2.84 218.65 5.06 194.79 3 125 M 3 243 C 3.64 200.88 3.33 157.41 3 125",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 103 L 83 3",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 103 M 3 103 C 21.58 80.95 34.84 60.95 83 3 M 3 103 C 21.26 79.81 39.07 56.84 83 3",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 L 163 243",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 M 3 243 C 35.9 245.15 68.21 245.61 163 243 M 3 243 C 50.67 244.88 100.13 244.32 163 243",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 243 L 163 123",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 243 M 163 243 C 162.82 219.13 161.51 195.47 163 123 M 163 243 C 162.74 198.88 163.16 152.43 163 123",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 103 L 83 3",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 103 M 163 103 C 145.21 82.15 130.51 62.73 83 3 M 163 103 C 142.06 77.83 122.22 52.91 83 3",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 123,
    width: 147,
    height: 113,
    fill: "#004c3f",
    stroke: "#004c3f",
    pointerEvents: "all"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacKfw55);
export default __webpack_public_path__ + "static/media/fac_kfw55.79ff31b5b8e1dcb4c4b07e1cb08165a8.svg";
export { ForwardRef as ReactComponent };